import moment from "moment";
import { tick } from "svelte";
import { get, writable } from "svelte/store";
import Analytics from "../../Analytics/Analytics";
import AppStore from "../../AppStore";
import AuthStore from "../../Auth/Store";
import DataFormat from "../../Enums/DataFormat";
import DownloadHelper from "../../Helpers/DownloadHelper";
import GeoHelper from "../../Helpers/GeoHelper";
import LocalStorageHelper from "../../Helpers/LocalStorageHelper";
import MapLayerManager from "../../Map/MapLayerManager";
import MapStore from "../../Map/Store";

const AnnotationsStore = {
	meta: {
		visible: writable(false)
	},
	data: {
		dummyButton: writable(null),
		blobUrl: "",
		blobFilename: writable("")
	},
	actions: {
		clearAll: () => {
			MapLayerManager.clearCustomMarkers(true);
			MapLayerManager.clearAnnotations();
			MapLayerManager.updateCustomMarkers();
			MapLayerManager.updateVisibleLayers();
			LocalStorageHelper.set("draw.customGeojson", JSON.stringify([]));
			LocalStorageHelper.set("draw.customMarkers", JSON.stringify([]));
			AppStore.snackbar.start("Annotations deleted!", "success");

			Analytics.event("delete_all", { category: "Annotations", username: get(AuthStore.userInfo).username });
		},
		exportGeojson: () => {
			AnnotationsStore.data.blobFilename.set("annotations-" + moment(new Date()).format("YYYYMMDD") + ".json");

			tick().then(() => {
				const consolidated = AnnotationsStore.helpers.getConsolidatedData();
				AnnotationsStore.data.blobUrl = DownloadHelper.asLink(consolidated, DataFormat.JSON);
				const a = get(AnnotationsStore.data.dummyButton);
				console.log(AnnotationsStore.data.blobUrl, a);
				a.href = AnnotationsStore.data.blobUrl;
				a.click();

				Analytics.event("export_geojson", { category: "Annotations", username: get(AuthStore.userInfo).username });
			});
		},
		exportCsv: () => {
			AnnotationsStore.data.blobFilename.set("annotations-" + moment(new Date()).format("YYYYMMDD") + ".csv");

			tick().then(() => {
				const consolidatedJson = AnnotationsStore.helpers.getConsolidatedData();

				const nl = "\r\n";
				let csv = `"shape_type","properties","coordinates"${nl}`;
				for (let i = 0; i < consolidatedJson.features.length; i++) {
					const feature = consolidatedJson.features[i];
					const shapeType = feature.geometry.type;
					const properties = JSON.stringify(feature.properties).replaceAll(/"/g, "\"\"");
					const coords = JSON.stringify(feature.geometry.coordinates);

					csv += `"${shapeType}","${properties}","${coords}"${nl}`;
				}

				AnnotationsStore.data.blobUrl = DownloadHelper.asLink(csv, DataFormat.CSV);
				const a = get(AnnotationsStore.data.dummyButton);
				console.log(AnnotationsStore.data.blobUrl, a);
				a.href = AnnotationsStore.data.blobUrl;
				a.click();

				Analytics.event("export_csv", { category: "Annotations", username: get(AuthStore.userInfo).username });
			});
		}
	},
	helpers: {
		getConsolidatedData: () => {
			const consolidated = GeoHelper.emptyGeoJson();

			const layers = get(MapStore.controlData.customGeojson.layers.input);
			for (let i = 0; i < layers.length; i++) {
				for (let j = 0; j < layers[i].features.length; j++) {
					const feature = layers[i].features[j];
					consolidated.features.push(feature);
				}
			}
			const markers = get(MapStore.controlData.draw.markers);
			for (let i = 0; i < markers.length; i++) {
				const point = GeoHelper.featureAt(markers[i].lng, markers[i].lat, markers[i].properties);
				point.properties.index = layers.length + i;
				consolidated.features.push(point);
			}
			return consolidated;
		}
	}
};
export default AnnotationsStore;
